module.exports = __webpack_public_path__ + "img/icon.778bc052.png";